import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Button } from 'primereact/button'
import { formatCurrency } from '../shared/utils'

const ORDER_SECTION_SELECTOR = '#my-order-section'

const OrderCartSummary = ({ total, itemCount, onViewOrder }) => {
  const [orderInView, setOrderInView] = useState(false)

  useEffect(() => {
    const target = document.querySelector(ORDER_SECTION_SELECTOR)
    if (!target) return

    const observer = new IntersectionObserver(
      ([entry]) => setOrderInView(entry.isIntersecting),
      {
        threshold: 0.12,
        rootMargin: '-72px 0px -52px 0px',
      }
    )

    observer.observe(target)
    return () => observer.disconnect()
  }, [itemCount])

  useEffect(() => {
    if (!itemCount || orderInView) {
      document.body.classList.remove('add-orders-cart-bar-visible')
      return
    }
    document.body.classList.add('add-orders-cart-bar-visible')
    return () => document.body.classList.remove('add-orders-cart-bar-visible')
  }, [itemCount, orderInView])

  if (!itemCount || orderInView) return null

  const summary = (
    <div
      className="order-cart-summary order-cart-summary--footer"
      role="region"
      aria-label="Current order summary"
    >
      <div className="order-cart-summary-info">
        <span className="order-cart-summary-label">Total</span>
        <span className="order-cart-summary-amount">
          {formatCurrency(total)}
        </span>
        <span className="order-cart-summary-separator" aria-hidden="true">
          ·
        </span>
        <span className="order-cart-summary-items">
          {itemCount} {itemCount === 1 ? 'item' : 'items'}
        </span>
      </div>
      <Button
        type="button"
        label="View Order"
        size="small"
        onClick={onViewOrder}
        className="order-cart-summary-btn"
      />
    </div>
  )

  return createPortal(summary, document.body)
}

export default OrderCartSummary
